export enum ActivityType {
  Unknown = 0,
  Award = 1,
  Book = 2,
  Grant = 3,
  Article = 4,
  ConferenceProceeding = 6,
  BookChapter = 7,
  Patent = 12,
  Technology = 13,
  OtherIntellectualProperty = 14,
  Performance = 30,
  Exhibit = 31,
  LiteraryWork = 32,
  Production = 33,
  OtherCreativeWork = 34,
  Presentation = 35,
  Reviewer = 36,
  CommunityEngagement = 37,
  Membership = 38,
  ClassroomEducationalMaterials = 40,
  OnlineEducationalMaterials = 41,
  SoftwareDigitalMedia = 50,
  Media = 51,
  ClinicalTrial = 60,
  ResearchDataSet = 70,
  FieldResearch = 71,
  Project = 72,
  Other = 99,
  OtherPublications = 100,
  GrantProposal = 101,
  Consulting = 110,
  Course = 112,
  Degree = 113,
  LicenseOrCertification = 114,
  Mentoring = 115,
  OtherContent = 117,
  ProfessionalDevelopment = 120,
  ProfessionalExperience = 121,
  ProfessionalService = 122,
  PublicService = 123,
  UniversityService = 126,
  OtherPedagogicalActivities = 127,
  FacultyLifeCycleEvents = 128,
  EducationalMaterials = 129,
}
